// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__20Jig","footer":"ModalCreateQualiphyProcedure_footer__1Vok8","additionData":"ModalCreateQualiphyProcedure_additionData__1523j"};